import { render } from "./DesignSystem.vue?vue&type=template&id=dd20ca88"
import script from "./DesignSystem.vue?vue&type=script&lang=js"
export * from "./DesignSystem.vue?vue&type=script&lang=js"

import "./DesignSystem.vue?vue&type=style&index=0&id=dd20ca88&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__